import { EngagementStatus } from "@gigsync/protocol";
import { bothSigned } from "../payments/passbook.js";
const S = EngagementStatus.enum;
/**
 * Activity's tabs, as collab's: what waits on the owner, what the agents are still talking over, and what is agreed.
 * Its fourth counter, Closed, is not a tab: it opens Records, so finished jobs live in one place only.
 */
export const ActivityTab = { awaiting: "awaiting", talks: "talks", agreed: "agreed" };
/** Over without the work being completed: cancelled after or before signing, declined, or left to expire. */
export const NOT_COMPLETED = new Set([S.cancelled, S.declined, S.expired]);
/**
 * Completed work, out of the jobs that are over: signed by both sides (or restored from the server's record) and
 * finished. A question that simply closed after an answer was never work, so it is in neither list.
 */
export function recordsOf(earlier) {
    const notDone = earlier.filter((job) => NOT_COMPLETED.has(job.engagement.status));
    const done = earlier.filter((job) => !NOT_COMPLETED.has(job.engagement.status) && (bothSigned(job) || job.restored !== undefined));
    return { done, notDone };
}
/** The groups as Activity's tabs: decide → Awaiting you, talking → In talks, signed work → Agreed, the rest → Records. */
export function activityOf(groups) {
    const { decide, talking, today, upcoming, other, earlier } = groups;
    return { awaiting: decide, talks: talking, agreed: { today, upcoming, other }, records: recordsOf(earlier) };
}
/** The counters; `moreAwaiting` adds what waits outside the jobs (a household's offers to work from a QR scan). */
export function countsOf(activity, moreAwaiting = 0) {
    const { today, upcoming, other } = activity.agreed;
    return {
        awaiting: activity.awaiting.length + moreAwaiting,
        talks: activity.talks.length,
        agreed: today.length + upcoming.length + other.length,
        closed: activity.records.done.length + activity.records.notDone.length,
    };
}
/** The tab Activity opens on: Awaiting you whenever something waits, else the first tab that has anything. */
export function firstTab(counts) {
    if (counts.awaiting > 0)
        return ActivityTab.awaiting;
    if (counts.talks > 0)
        return ActivityTab.talks;
    if (counts.agreed > 0)
        return ActivityTab.agreed;
    return ActivityTab.awaiting;
}
//# sourceMappingURL=activity.js.map